import { axiosInstance } from '../Axios';
const { createSlice } = require('@reduxjs/toolkit');

const TripjackReducer = createSlice({
	name: 'Tripjack',
	initialState: {
		success: false,
		error: null,
		loadtrip: false,
		tjkresult: null,
	},
	reducers: {
		searchTripRequest(state, action) {
			state.loadtrip = true;
		},
		searchSuccessTJK(state, action) {
			state.loadtrip = false;
			state.tjkresult = action.payload;
			state.error = null;
		},
		searchTripFail(state, action) {
			state.loadtrip = false;
			state.error = action.payload;
		},
	},
});

const { actions } = TripjackReducer;
const config = {
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Client-Service': 'srk-client',
		'Auth-Key': 'srkapi',
		'Api-Key': 'NjO7hqe3PG9musafi==',
	},
};
export const { searchTripRequest, searchSuccessTJK, searchTripFail } = actions;
export const SearchTripjackDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(searchSuccessTJK(null));
		dispatch(searchTripRequest());
		const tjk = await axiosInstance.post(
			'FlyTjk/flightsearch',
			bodyData,
			config
		);

		dispatch(searchSuccessTJK(tjk.data));
		console.log('TJK', tjk.data);
	} catch (error) {
		dispatch(
			searchTripFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export default TripjackReducer;
